import { Box, H1, Spinner } from '@betterment/samba-react';

import { Header } from './Header';

import { WithLayout } from '../../RetailApp/components/WithLayout';

export const Loading: React.FC = () => {
  return (
    <WithLayout parts={{ sidebar: false }}>
      <Header />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
        }}
      >
        <Spinner size="lg" css={{ marginBottom: 'space.400' }} />
        <H1>Looking for your invitation</H1>
      </Box>
    </WithLayout>
  );
};
